import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MenubarModule } from 'primeng/menubar';
import { AvatarModule } from 'primeng/avatar';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { InputMaskModule } from 'primeng/inputmask';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectButtonModule } from 'primeng/selectbutton';
import { PasswordModule } from 'primeng/password';

import { PageComponent } from './page/page.component';
import { PatientTitleComponent } from './patient-title/patient-title.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { WidgetComponent } from './widget/widget.component';
import { InsuranceDetailsComponent } from './insurance-details/insurance-details.component';
import { FormFieldComponent } from './form-field/form-field.component';
import { NumberStepInputComponent } from './number-step-input/number-step-input.component';
import { FormModalComponent } from './form-modal/form-modal.component';

import {
  FormatAddressPipe,
  FormatBooleanPipe,
  FormatCurrencyPipe,
  FormatDatePipe,
  FormatPhonePipe,
} from '../core/utils/pipes';

import { FormFooterComponent } from './form-footer/form-footer.component';
import { RadioButtonCardComponent } from './radio-button-card/radio-button-card.component';
import { CheckboxModule } from 'primeng/checkbox';
import { PaymentMethodDetailsComponent } from './payment-method-details/payment-method-details.component';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { MessagesModule } from 'primeng/messages';
import { ProductItemQuantityWarningComponent } from './product-item-quantity-warning/product-item-quantity-warning.component';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { FooterComponent } from '../home/footer/footer.component';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { PageErrorComponent } from './page-error/page-error.component';
import { OrderStatusTagComponent } from './order-status-tag/order-status-tag.component';
import { TagModule } from 'primeng/tag';
import { OrdersListComponent } from './orders-list/orders-list.component';
import { TableModule } from 'primeng/table';
import { NotificationOverlayComponent } from './notification-overlay/notification-overlay.component';
import { BlockUIModule } from 'primeng/blockui';
import { MessageComponent } from './message/message.component';
import { DirectivesModule } from '../core/directives/directives.module';
import { PanelModule } from 'primeng/panel';
import { LoginPageComponent } from './login-page/login-page.component';
import { ContentContainerComponent } from './content-container/content-container.component';
import { InsuranceFormComponent } from './insurance-form/insurance-form.component';
import { DividerModule } from 'primeng/divider';
import { AddressFormComponent } from './address-form/address-form.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AddressOrdersFormComponent } from './address-orders-form/address-orders-form.component';
import { TimelineModule } from 'primeng/timeline';
import { OrderStatusTimelineComponent } from './order-status-timeline/order-status-timeline.component';
import { PaymentMethodFormComponent } from './payment-method-form/payment-method-form.component';
import { PaymentMethodRadioComponent } from './payment-method-radio/payment-method-radio.component';
import { GlyphSpinnerComponent } from './glyph-spinner/glyph-spinner.component';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { PharmOrdersComponent } from './pharm-orders/pharm-orders.component';
import { PasswordCheckerComponent } from './password-checker/password-checker.component';
import { SeparatorComponent } from './separator/separator.component';
import { MobileFooterComponent } from './mobile-footer/mobile-footer.component';

@NgModule({
  providers: [TitleCasePipe, FormatAddressPipe],
  declarations: [
    FormatAddressPipe,
    FormatBooleanPipe,
    FormatPhonePipe,
    FormatDatePipe,
    FormatCurrencyPipe,
    PageComponent,
    PatientTitleComponent,
    SpinnerComponent,
    WidgetComponent,
    InsuranceDetailsComponent,
    FormFieldComponent,
    NumberStepInputComponent,
    FormModalComponent,
    FormFooterComponent,
    RadioButtonCardComponent,
    ProductDetailsComponent,
    PaymentMethodDetailsComponent,
    ProductItemQuantityWarningComponent,
    ConfirmationModalComponent,
    FooterComponent,
    PageErrorComponent,
    OrderStatusTagComponent,
    OrdersListComponent,
    PharmOrdersComponent,
    NotificationOverlayComponent,
    MessageComponent,
    LoginPageComponent,
    ContentContainerComponent,
    InsuranceFormComponent,
    AddressFormComponent,
    AddressOrdersFormComponent,
    PaymentMethodFormComponent,
    PaymentMethodRadioComponent,
    OrderStatusTimelineComponent,
    GlyphSpinnerComponent,
    PasswordCheckerComponent,
    SeparatorComponent,
    MobileFooterComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MenubarModule,
    AvatarModule,
    CardModule,
    InputTextModule,
    InputNumberModule,
    DropdownModule,
    CalendarModule,
    RadioButtonModule,
    DialogModule,
    InputMaskModule,
    CheckboxModule,
    MultiSelectModule,
    SelectButtonModule,
    MessagesModule,
    TieredMenuModule,
    PanelModule,
    TagModule,
    TableModule,
    BlockUIModule,
    DirectivesModule,
    PasswordModule,
    DividerModule,
    AutoCompleteModule,
    TimelineModule,
    InputTextareaModule,
  ],
  exports: [
    FormatAddressPipe,
    FormatBooleanPipe,
    FormatPhonePipe,
    FormatDatePipe,
    FormatCurrencyPipe,
    PageComponent,
    PatientTitleComponent,
    SpinnerComponent,
    WidgetComponent,
    InsuranceDetailsComponent,
    FormFieldComponent,
    NumberStepInputComponent,
    FormModalComponent,
    FormFooterComponent,
    RadioButtonCardComponent,
    ProductDetailsComponent,
    PaymentMethodDetailsComponent,
    ProductItemQuantityWarningComponent,
    ConfirmationModalComponent,
    FooterComponent,
    PageErrorComponent,
    OrderStatusTagComponent,
    OrdersListComponent,
    PharmOrdersComponent,
    NotificationOverlayComponent,
    MessageComponent,
    LoginPageComponent,
    ContentContainerComponent,
    InsuranceFormComponent,
    AddressFormComponent,
    AddressOrdersFormComponent,
    PaymentMethodFormComponent,
    PaymentMethodRadioComponent,
    OrderStatusTimelineComponent,
    GlyphSpinnerComponent,
    PasswordCheckerComponent,
    SeparatorComponent,
    MobileFooterComponent,
  ],
})
export class SharedModule {}
